const appendUnique = (list, value) => {
  if (value && !list.includes(value)) {
    list.push(value);
  }
};

export const getUserDistributorIds = (user = {}) => (
  Array.isArray(user?.distributors)
    ? user.distributors.filter(Boolean)
    : []
);

export const getUserDistributors = (user = {}, distributors = []) => {
  const distributorIds = new Set(getUserDistributorIds(user));

  return distributors.filter((distributor) => distributorIds.has(distributor?.id));
};

export const getUserCountries = (user = {}, distributors = []) => {
  const countries = [];

  appendUnique(countries, user?.country);
  user?.administrationCountries?.forEach((country) => appendUnique(countries, country));
  getUserDistributors(user, distributors).forEach((distributor) => appendUnique(countries, distributor?.country));

  return countries;
};

export const getUserCompanies = (user = {}, distributors = []) => {
  const companies = [];

  appendUnique(companies, user?.company);
  getUserDistributors(user, distributors).forEach((distributor) => appendUnique(companies, distributor?.company));

  return companies;
};
